import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { take } from "rxjs/operators";
import { AppTranslateService } from "src/app/core/service/app-translate.service";
import { AuthService } from "src/app/core/service/auth.service";
import { NotifyComponent } from "src/app/shared/components/notify/notify.component";
import { AppService } from "src/app/shared/service/app.service";
import { LoaderService } from "src/app/shared/service/loader.service";

import { MustMatch } from "src/app/_helpers/must-match.validator";

@Component({
  selector: "app-nav",
  templateUrl: "./nav.component.html",
  styleUrls: ["./nav.component.scss"],
})
export class NavComponent implements OnInit {
  @ViewChild("closeBtn", { static: true }) closeBtn;
  @ViewChild("closeBtn2", { static: true }) closeBtn2;
  @Output() callChatBox = new EventEmitter();

  @ViewChild(NotifyComponent, {static:true}) notifyComponent: NotifyComponent;

  @ViewChild("firstElement") firstElement: ElementRef;
  @ViewChild("stay") stay: ElementRef;

  public user: any;
  passwordForm: FormGroup;
  loading = false;
  submitted = false;

  public language: any = [];
  public currentLang: string = "";

  // <!-- Property declaration -->
  fieldTextType1: boolean;
  fieldTextType2: boolean;
  fieldTextType3: boolean;

  isCollapsed = true;

  toggleSidebarPin() {
    this.appService.toggleSidebarPin();
  }
  toggleSidebar() {
    this.appService.toggleSidebar();
  }

  switchLang(lang: string) {
    this.appTranslate.switchLang(lang);
  }

  // <!-- Switching method -->
  toggleFieldTextType(num) {
    if (num === 1) {
      this.fieldTextType1 = !this.fieldTextType1;
    } else if (num === 2) {
      this.fieldTextType2 = !this.fieldTextType2;
    } else if (num === 3) {
      this.fieldTextType3 = !this.fieldTextType3;
    }
  }

  constructor(
    private authService: AuthService,
    private appService: AppService,
    public toastr: ToastrService,
    private router: Router,
    private formBuilder: FormBuilder,
    public appTranslate: AppTranslateService,
    private loaderService: LoaderService
  ) {
    this.language = this.appTranslate.getLangList();
    this.currentLang = this.appTranslate.currentLang();
    this.appTranslate.switchLang(this.currentLang);
    // console.log("this.language==>", this.language);
    // console.log("this.currentLang==>", this.currentLang);
  }

  ngOnInit() {
    this.user = this.authService.userValue;
    this.createForm();
  }

  createForm() {
    this.passwordForm = this.formBuilder.group(
      {
        currentPassword: ["", Validators.required],
        newPassword: ["", [Validators.required, Validators.minLength(6)]],
        confirmPassword: ["", Validators.required],
      },
      {
        validator: MustMatch("newPassword", "confirmPassword")
      }
    );
  }

  get f() {
    return this.passwordForm.controls;
  }

  public closeModalFn() {
    this.submitted = false;
    this.passwordForm.reset();
    this.modalClose();
  }

  public modalClose() {
    this.closeBtn.nativeElement.click(); // call modal close button
    this.closeBtn2.nativeElement.click(); // logout modal close button
  }
  public logOut() {
    this.modalClose();
    this.loaderService.show();
    if (this.appTranslate.currentLang() == "sv") {
      this.toastr.success("Logga ut!", "Framgång", {
        timeOut: 2000,
      });
    } else {
      this.toastr.success("Log Out!", "Success", {
        timeOut: 2000,
      });
    }
    this.authService.logout();
    this.loaderService.hide();
  }

  resetPassword() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.passwordForm.invalid) {
      return;
    }
    const pwdData = {
      Email: this.user.emailId,
      UserName: this.user.userName,
      CurrentPassword: this.passwordForm.controls.currentPassword.value,
      NewPassword: this.passwordForm.controls.newPassword.value,
    };
    this.authService
      .changePassword(pwdData)
      .pipe(take(1))
      .subscribe(
        (res) => {
          this.closeModalFn();
          if (this.appTranslate.currentLang() == "sv") {
            this.toastr.success("Lösenordet ändrat!", "Framgång", {
              timeOut: 2000,
            });
          } else {
            this.toastr.success("Password Changed!", "Success", {
              timeOut: 2000,
            });
          }
  
        },
        (err) => {
          if (this.appTranslate.currentLang() == "sv") {
            this.toastr.error("Ändring av lösenord misslyckades!", "Fel", {
              timeOut: 2000,
            });
          } else {
            this.toastr.error("Change Password failed!", "Error", {
              timeOut: 2000,
            });
          }
        }
      );
  }

  autoFocusFn() {
    setTimeout(() => {
      this.firstElement.nativeElement.focus();
    }, 500);
  }

  autoFocusStayFn() {
    setTimeout(() => {
      this.stay.nativeElement.focus();
    }, 500);
  }


  public callNofityFn(){
    this.notifyComponent.getNotify();
  }

  public chatCall(data:any){
    this.callChatBox.emit(data);
  }
}
